document.addEventListener("DOMContentLoaded", function () {
  const popup = document.getElementById("custom-popup");
  const cancelPopup = document.getElementById("cancel-popup");
  const form = document.getElementById("popup-form");

  // Show popup after a delay
  setTimeout(() => {
    popup.classList.remove("hidden");
  }, 3000);

  // Cancel button functionality
  if (cancelPopup) {
    cancelPopup.addEventListener("click", function (event) {
      event.preventDefault(); // Prevent default action
      console.log("Cancel button clicked");
      popup.classList.add("hidden");
    });
  }

  // Form submission functionality
  if (form) {
    form.addEventListener("submit", function (event) {
      event.preventDefault(); // Prevent default form behavior
      const formData = new FormData(form);
      const email = formData.get("email");

      // Log or send the email
      console.log("Email submitted:", email);

      // Use fetch to send data to your backend (adjust the URL accordingly)
      fetch('/path-to-your-backend-endpoint', {
        method: 'POST',
        body: JSON.stringify({ email: email }),
        headers: {
          'Content-Type': 'application/json',
        },
      })
        .then(response => {
          if (response.ok) {
            console.log('Email successfully submitted');
            popup.classList.add("hidden");
          } else {
            console.error('Error submitting email');
          }
        })
        .catch(error => {
          console.error('Error:', error);
        });
    });
  }
});
